// ユーザロール
export const ROLE = {
    admin: 1,
    general: 2,
    viewer: 3,
}
